import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfigFile from "../css/tailwind.config.js";
import axios from "axios";
import * as XLSX from "xlsx/xlsx.mjs";
import moment from "moment";
import { toast } from "react-toastify";
import { requestGet } from "../api/coreInstance.js";
import { requestAuthGet } from "../api/authInstance.js";
import _ from "lodash";

export const tailwindConfig = () => {
  // Tailwind config
  return resolveConfig(tailwindConfigFile);
};

export const hexToRGB = (h) => {
  let r = 0;
  let g = 0;
  let b = 0;
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }
  return `${+r},${+g},${+b}`;
};

export const formatValue = (value) =>
  Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumSignificantDigits: 3,
    notation: "compact",
  }).format(value);

export const formatThousands = (value) =>
  Intl.NumberFormat("en-US", {
    maximumSignificantDigits: 3,
    notation: "compact",
  }).format(value);

export const logger = (...args) => {
  if (process.env.NODE_ENV === "development") {
    console.log(...args);
  }
};

export const formatAccountNumber = (str) => {
  return str.replace(/(.{4})/g, "$1 ").trim();
};

export const getDataAxios = async (url) =>
  await axios.get(url, { headers: HEADER }).then((res) => res);

export const HEADER = {
  "Content-Type": "application/json",
  "X-Kartini-Signature": "a2FydGluaUAyMDIy",
};

export const formatPhoneNumberIndonesia = (phoneNumber) => {
  // Remove all non-numeric characters from the input string
  phoneNumber = phoneNumber.replace(/\D/g, "");

  // Check if the phone number starts with a valid prefix
  const prefixRegex = /^(62)/;
  if (prefixRegex.test(phoneNumber)) {
    // If the prefix is missing or invalid, return the original input
    return phoneNumber;
  }

  // Remove the leading "0" and "62" if the number starts with it
  phoneNumber = phoneNumber.replace(/^(0|\+)/, "");

  // Add the country code "62" to the phone number
  phoneNumber = "62" + phoneNumber;

  return phoneNumber;
};

export const isValidEmail = (email) => {
  // Define a regular expression pattern for a simple email validation
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Test the email against the pattern and return the result
  return pattern.test(email);
};

export const isValidPhoneNumber = (phoneNumber) => {
  // Define a regular expression pattern for a phone number validation
  // This pattern ensures the phone number consists of at least 10 digits
  const pattern = /^\d{9,}$/;

  // Test the phone number against the pattern and return the result
  return pattern.test(phoneNumber);
};

export const ExportToExcel = (fileName, data) => {
  let ws = XLSX.utils.json_to_sheet(data);
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "sheet");
  XLSX.writeFile(
    wb,
    `${fileName}-${moment(new Date()).format("DDMMYYHHmmss")}.xlsx`,
  );
};

export const ExportAuthTableExcel = (url, params, columnMapping) => {
  requestAuthGet(`${url}`, {
    params: { ...params, limit: 999999999999999 },
  }).then(function (res) {
    let data = Array.isArray(res.data.data) ? res.data.data : [res.data.data];

    if (!_.isEmpty(columnMapping)) {
      data = data.map((_data) => {
        let mappingData = {};

        columnMapping.forEach((column) => {
          const keys = column.key.split(".");
          let value = _data;

          keys.forEach((key) => {
            if (!_.isEmpty(value)) {
              value = value[key];
            }
          });

          if (column.key === "createdAt" && value) {
            value = moment.utc(value).local().format("YYYY-MM-DD HH:mm:ss");
          }

          mappingData[column.header] = value;
        });

        return mappingData;
      });
    }

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "report");
    XLSX.writeFile(
      wb,
      `Report-${moment(new Date()).format("DDMMYYHHmmss")}.xlsx`,
    );
  });
};

export const ExportAuthTableExcelDownload = async (url, params, filename) => {
  let toastId;

  try {
    toastId = toast.loading("Exporting data... 0% completed", {
      position: "bottom-center",
      hideProgressBar: true,
    });
    const response = await requestAuthGet(url, {
      params,
      responseType: "blob",
    });

    const contentType = response.data.type;

    const blob = new Blob([response.data], { type: contentType });

    let fileName =
      `${filename}_Report_${moment().format("YYYYMM")}` ||
      `Report-${moment().format("YYYYMM")}.xlsx`;
    const contentDisposition = response.headers["content-disposition"];

    if (contentDisposition && contentDisposition.includes("filename=")) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        fileName = decodeURIComponent(match[1]);
      }
    }

    const urlBlob = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = urlBlob;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(urlBlob);

    toast.update(toastId, {
      render: "Export completed successfully!",
      type: "success",
      isLoading: false,
      autoClose: 1500,
    });
  } catch (error) {
    toast.update(toastId, {
      render: "An error occurred while exporting data.",
      type: "error",
      isLoading: false,
      autoClose: 1500,
    });
    console.error("❌ Error downloading Excel:", error);
    throw error;
  }
};

export const ExportAuthTableExcelQueue = async (
  filename,
  url,
  params,
  limit,
  columnMapping,
) => {
  let allData = [];
  let toastId; // To store the toast ID for updating progress

  try {
    let page = 1;
    let totalPages = 1;

    // Show the initial toast and store its ID
    toastId = toast.loading("Exporting data... 0% completed", {
      position: "bottom-center",
      hideProgressBar: true,
    });

    // Function to fetch data for a single URL
    const fetchData = async (url) => {
      const initialRes = await requestAuthGet(`${url}`, {
        params: { ...params, limit, page },
      });
      totalPages = initialRes.data.pageCount;

      while (true) {
        const res = await requestAuthGet(`${url}`, {
          params: { ...params, limit, page },
        });
        const data = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];

        if (data.length === 0) break;

        allData = allData.concat(data);

        // Update progress percentage
        const progress = Math.min((page / totalPages) * 100, 100).toFixed(0);
        if (toastId) {
          toast.update(toastId, {
            render: `Exporting data... ${progress}% completed`,
          });
        }

        if (page >= res.data.pageCount) break;
        page++;
      }
    };

    // Check if url is an array or a string
    if (Array.isArray(url)) {
      for (const singleUrl of url) {
        await fetchData(singleUrl);
      }
    } else {
      await fetchData(url);
    }

    if (columnMapping && columnMapping.length > 0) {
      allData = allData.map((_data) => {
        let mappingData = {};

        columnMapping.forEach((column) => {
          mappingData[column.header] = column?.mapping
            ? column.mapping(
                !_.isEmpty(column.key) ? _.get(_data, column.key, "") : _data,
              )
            : _.get(_data, column.key, "");
        });

        return mappingData;
      });
    }

    const ws = XLSX.utils.json_to_sheet(allData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "report");
    XLSX.writeFile(
      wb,
      `${filename} Report_${moment(new Date()).format("DDMMYYHHmmss")}.xlsx`,
    );

    // Update the toast to success
    toast.update(toastId, {
      render: "Export completed successfully!",
      type: "success",
      isLoading: false,
      autoClose: 1500,
    });
  } catch (error) {
    console.error("Error fetching data:", error);
    if (allData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(allData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "report");
      XLSX.writeFile(
        wb,
        `-${filename} Report_${moment(new Date()).format("DDMMYYHHmmss")}.xlsx`,
      );
    }

    // Update the toast to error
    toast.update(toastId, {
      render: "An error occurred while exporting data.",
      type: "error",
      isLoading: false,
      autoClose: 1500,
    });
    throw error;
  }
};

export function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
}

export const GetBalance = async (channel_id, project_id) => {
  let projects;
  try {
    if (!project_id) {
      projects = await requestGet(
        `/v2/collection/project/data?channel_id=${channel_id ?? ""}`,
      );

      projects = projects.data.data
        .map((_project) => _project.project_id)
        .toString();
    }

    let balance = await requestGet(
      `/v2/collection/mitra/ewallet/detail/${channel_id}?project_id=${
        project_id ?? projects
      }`,
    );
    return {
      ewallet_balance: balance.data.data.ewallet_balance,
      deposit_balance: balance.data.data.deposit_balance,
      transit_balance: balance.data.data.transit_balance,
    };
  } catch (error) {
    console.error(error);
  }
};

/**
 * Fetches data options asynchronously and updates the options state.
 * @param {Array} data - An array of objects containing the `key` and `url` properties.
 * @param {Function} setOptions - A function to update the options state.
 */
export const GetDataOptions = async (data, setOptions, setIsLoading) => {
  setIsLoading(true);
  try {
    for (const detail of data) {
      setOptions((prevState) => ({
        ...prevState,
        [detail.name]: {
          data: prevState[detail.name]?.data ?? [],
          isLoading: true,
        },
      }));

      const res = await requestAuthGet(`${detail.url}`);

      setOptions((prevState) => ({
        ...prevState,
        [detail.name]: {
          data: res.data.data.map((option) => ({
            ...option,
            label:
              typeof detail.label === "function"
                ? detail.label(option)
                : _.get(option, detail.label),

            value:
              typeof detail.key === "function"
                ? detail.key(option)
                : option[detail.key],
          })),
          isLoading: false,
        },
      }));
    }
    setIsLoading(false);
  } catch (error) {
    console.error(error);
    setIsLoading(false);
  }
};

export const validateInput = (inputValue, validationString) => {
  const rules = validationString.split("|");

  // Iterate through each rule and apply the validation
  for (const rule of rules) {
    switch (rule.trim()) {
      case "nullable":
        // Check if the value is nullable
        if (inputValue === "") {
          return true; // Validation passed
        }
        break;
      case "required":
        // Check if the value is empty
        if (inputValue === "") {
          return false; // Validation failed
        }
        break;
      case "email":
        // Check if the value is a valid email
        return (
          inputValue.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) !==
          null
        );
      case "+62":
        return inputValue.match(/^(?:\+62)?8[0-9]{8,}$/) !== null;

      default:
        // Handle unknown rule (you can throw an error or ignore it)
        console.warn(`Unknown validation rule: ${rule}`);
    }
  }

  // If no validation rule fails, return true
  return true;
};

export const toastNotify = (message, type) => {
  toast(message, {
    type: type,
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

/**
 * Asynchronously displays a toast message based on the outcome of a given promise.
 *
 * @param {string} message - The message to be displayed in the toast.
 * @param {Promise} promise - The promise whose outcome determines the toast content.
 */
export const toastPromise = async (message, promise) => {
  await toast.promise(promise, {
    pending: {
      render() {
        return `Loading ${message}...`;
      },
      position: "bottom-center",
      hideProgressBar: true,
    },
    success: {
      render() {
        return `Success ${message}`;
      },
      position: "bottom-center",
      hideProgressBar: true,
      closeButton: false,
      autoClose: 1500,
    },
    error: {
      render() {
        return `Error ${message}`;
      },
      position: "bottom-center",
      hideProgressBar: true,
    },
  });
};
export const sheetNotify = (data, setSheetDetail) => {
  setSheetDetail({
    title: data.title,
    detail: data.detail,
    open: true,
    icon: data.icon,
    buttonLabel: data.buttonLabel,
    buttonAction: data.buttonAction,
    children: data.children,
  });
};

export function generateArrayPages(n) {
  return Array.from({ length: n }, (_, i) => i + 1);
}

export function formatToRupiahValue(amount) {
  // Format the amount to IDR currency
  let formatted = parseInt(amount).toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formatted;
}

export function formatRupiah(angka, prefix) {
  angka = typeof angka === "string" ? angka : angka?.toString();
  var number_string = angka?.replace(/[^,\d]/g, "")?.toString(),
    split = number_string?.split(","),
    sisa = split?.length > 0 && split[0].length % 3,
    rupiah = split?.length > 0 && split[0].substr(0, sisa),
    ribuan = split?.length > 0 && split[0].substr(sisa).match(/\d{3}/gi);

  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah =
    split?.length > 0 && split[1] != undefined
      ? rupiah + "," + split?.length > 0 && split[1]
      : rupiah;
  return prefix == undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
}

export function formatPhoneNumber(inputNumber) {
  // Remove any non-digit characters from the input
  const cleanedNumber = inputNumber.replace(/\D/g, "");

  // Handle different cases for input numbers
  if (cleanedNumber.startsWith("0")) {
    // Replace the '0' with the country code '62'
    const formattedNumber = "62" + cleanedNumber.slice(1);
    return formattedNumber;
  } else if (cleanedNumber.startsWith("62")) {
    // Already starts with '62', assume correctly formatted
    return cleanedNumber;
  } else {
    // Prepend '62' if the number does not start with '0' or '62'
    const formattedNumber = "62" + cleanedNumber;
    return formattedNumber;
  }
}
